import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=32f6a3a0&scoped=true&"
import script from "./Forgot.js?vue&type=script&lang=js&"
export * from "./Forgot.js?vue&type=script&lang=js&"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=32f6a3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6a3a0",
  null
  
)

export default component.exports